import type { PublicGalleryAuthor } from '~/types/public-gallery'

export function publicGalleryAuthorName (author: PublicGalleryAuthor | null | undefined) {
  const displayName = author?.displayName?.trim()
  return displayName || 'SuperSeeded member'
}

export function publicGalleryAuthorInitial (author: PublicGalleryAuthor | null | undefined) {
  const name = author?.displayName?.trim()
  if (!name) {
    return ''
  }

  return Array.from(name)[0]?.toUpperCase() || ''
}
